import React, { useRef, useState } from 'react';
import { DataGrid, Popup } from 'devextreme-react';
import {
    Paging,
    Pager,
    FilterRow,
    HeaderFilter,
    ColumnChooser,
    Column,
    Lookup,
    Editing
} from 'devextreme-react/data-grid';
import { createStoreLocal } from '../../utils/proxy';
import Title from '../../components/shared/Title';
import BlockHeader from '../../components/shared/BlockHeader';
import { store } from '../../services/store';

import CustomButton from '../../components/buttons/CustomButton';
import { _path } from "../../data/headerNavigation";
import { dataAccess, formatDate, formatDateTime, resources } from '../../data/app';
import toCapital, { cellAsPayoff, cellRender, dataFormatId, formatId, padIdInfoData } from '../../utils/common';
import urlReport from '../../services/reportServices';
import useAuthorization from '../../hooks/useAuthorization';
import { billDialogAction } from '../../store/bill/billDialogReducer';
import Nuevo from './Nuevo';
import { useDispatch, useSelector } from 'react-redux';
import { getConfig, typesBill } from '../../data/bill';
import http from '../../utils/http';
import notify from 'devextreme/ui/notify';
import { confirm } from 'devextreme/ui/dialog';
import ReceiptByBillId from '../receipts/ReceiptByBillId';
import * as NuevoReceipt from '../../components/bill/Nuevo';
import uri from '../../utils/uri';
import { useEffect } from 'react';

const List = props => {

    const { typeId, clientId = null, history } = props;

    const config = getConfig(typeId);
    const isBill = typeId == typesBill.factura;

    const { billPayment, appInfo } = useSelector(store => store);

    const [dialogReceipt, setDialogReceipt] = useState({ open: false, id: 0, reference: 0 });
    const [dataDialog, setDataDialog] = useState({ id: 0, billId: 0, open: false, client: '', balance: '' });

    const { authorized, auth } = useAuthorization([resources.facturacion, dataAccess.access]);
    const dispatch = useDispatch();
    let refGrid = useRef();

    const addMenuItems = (e) => {

        if (e.target == "content") {

            // e.items can be undefined
            if (!e.items) e.items = [];

            // Add a custom menu item
            if (e.rowIndex >= 0) {

                const { id, clientId, nombre, balance, numberBill, payoff } = e.row.data;

                e.items.push({

                    text: `Nueva ${config.text}`,
                    icon: 'doc',
                    onItemClick: () => {                  

                        dispatch(billDialogAction({ open: true, id: 0, clientId }));

                    }

                });

                e.items.push({

                    text: `Ver ${config.text}`,
                    icon: 'doc',
                    onItemClick: () => dispatch(billDialogAction({ open: true, id }))

                });

                if (clientId == null) {
                    e.items.push({

                        text: 'Ver ficha',
                        icon: 'user',
                        onItemClick: () => history.push('/clinica/cliente/' + clientId)

                    });
                }
                

                if (!payoff && isBill){

                    e.items.push({
                        
                        text: `Pagar ${config.text}`,
                        icon: 'money',
                        onItemClick: () => {
                            setDataDialog({ id: 0, billId: id, open: true, client: nombre, balance });
                        }
                        
                    });
                }

                e.items.push({

                    text: `Imprimir ${config.text}`,
                    icon: 'print',
                    onItemClick: () => {
                        const report = urlReport();

                        if(isBill)
                            report.print(`${report.billTicket(id)}`);
                        else
                            report.print(`${report.cotizacion(id)}`);
                    }

                }, {

                    text: `Anular ${config.text}`,
                    icon: 'remove',
                    disabled: !auth.toDelete,
                    onItemClick: () => {
                        refGrid.current.instance.deleteRow(e.rowIndex);

                    },
                    color: 'red'
                });

                if (typeId == typesBill.factura && e.row.data.typeId == typesBill.factura) {
                    e.items.push({

                        text: `Ver recibos`,
                        icon: 'doc',
                        //disabled : !auth.toDelete,
                        onItemClick: () => {

                            setDialogReceipt({ open: true, id, reference:numberBill, cliente:nombre })

                            //refGrid.current.instance.deleteRow(e.rowIndex);                        

                        },

                    })
                }

                if (typeId == typesBill.cotizacion) {

                    e.items.push({

                        text: `Convertir en factura`,
                        icon: 'export',
                        onItemClick: () => {

                            let result = confirm(`<i>Convertir la cotización ${id} en factura?</i>`, "Confirmar");

                            result.then((dialogResult) => {
                                if (dialogResult)
                                    http(`quotations/${id}/makebill`).asPost().then(resp => {
                                        onSave();
                                        notify(`Con creo la factura ${resp.id} correctamente`);
                                    });
                            });

                        }

                    });
                }
            }
        }
    }

    const onRowPrepared = (e) => {
        if (e.rowType == 'data') {
            if (!e.data.active)
                e.rowElement.classList.add('no-activo');

        }
    }

    const onToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Exportar a excel',
                icon: 'xlsxfile',
                type: 'success',
                stylingMode: "outlined",
                onClick: () => refGrid.current.instance.exportToExcel(false)
            }
        });
    }

    const onCellPrepared = e => {

        const cellsQuantity = ['payoff']

        if (e.rowType == 'data' && e.column.allowEditing) {
            if (cellsQuantity.includes(e.column.dataField))
                if (e.row.data.payoff)
                e.cellElement.classList.add('pagada');
                else{
                    if (!e.row.data.payoff && e.row.data.balance > 0)
                        e.cellElement.classList.add('pendiente');
                    else
                        e.cellElement.classList.add('stanby');

                }

            if (e.column.dataField == 'numberBill' && e.data.typeId == typesBill.factura)
                e.cellElement.classList.add('col-id-factura');

            if (e.column.dataField == 'id' && e.data.typeId == typesBill.cotizacion)
                e.cellElement.classList.add('col-id-cotizacion');

            if (e.column.dataField == 'numberBill' && e.data.typeId == typesBill.factura)
                e.cellElement.classList.add('text-bold');
        }

    }

    const onSave = bill => {

        refGrid.current.instance.refresh();

        http(uri.bill.get).asGet({
            id: bill.id,
            take: 10,
            skip: 0
        }).then(info => {

            let [data] = info.items;
            if (data.paymentTypeId == 2) //credito
                setDataDialog({ id: 0, billId: data.id, open: true, client: data.nombre, balance: data.balance });

        });

    }

    const openDialog = e => {
        setDataDialog({ id: 0, billId: e.row.data.id, open: true, client: e.row.data.nombre, balance: e.row.data.balance });
    }

    const close = e => {
        setDataDialog({ id: 0, billId: 0, open: false, client: '', balance: '' });
    }

    const extraParameter = clientId != null ? { key: 'clientId', value: clientId } : null;

    const title = toCapital(config.title);

    useEffect(() => {

        refGrid.current.instance.refresh();
        
    }, [billPayment]);

    const padId = padIdInfoData(appInfo);

    return authorized(
        <div className="container" value={{...billPayment}}>
            <Title title={title} />
            <BlockHeader title={title}>
                <CustomButton
                    type="default"
                    text={`Nueva ${config.text}`}
                    icon='plus'
                    onClick={() => {
                        dispatch(billDialogAction({ open: true, clientId }));
                    }}
                />
            </BlockHeader>
            <Popup
                width={800}
                height={400}
                title={`Recibos`}
                onHiding={e => setDialogReceipt({ open: false, id: 0 })}
                visible={dialogReceipt.open}
                className="bg-fbfbfb"
            >
                <ReceiptByBillId id={dialogReceipt.id} reference={dialogReceipt.reference} onSave={onSave} cliente={dialogReceipt.cliente} />
            </Popup>
            <Nuevo onSave={onSave} config={config} />
            <NuevoReceipt.default data={dataDialog} close={close} onSave={() => 0} />
            <DataGrid id="gridContainer"
                ref={refGrid}
                selection={{ mode: 'single' }}
                dataSource={store({ uri: config.uri, remoteOperations: true, extraParameter })}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                rowAlternationEnabled={true}
                hoverStateEnabled={true}
                onContextMenuPreparing={addMenuItems}
                onRowPrepared={onRowPrepared}
                onCellPrepared={onCellPrepared}
                remoteOperations={{
                    paging: true,
                    filtering: true
                }}
            >
                <Paging defaultPageSize={10} />
                <Pager
                    showInfo={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50]}
                />
                <FilterRow visible={true} />
                <HeaderFilter visible={true} />
                <ColumnChooser enabled={true} />
                <Column dataField="id" width={90}  caption={`Id`} visible={typeId == typesBill.cotizacion} cellRender={dataFormatId}/>
                <Column dataField="numberBill" width={110} caption="No Factura" alignment="right" cellRender={padId} visible={typeId == typesBill.factura} />
                <Column dataField="date" caption="Fecha" dataType='date' format={formatDate} width={120} />
                <Column dataField="nombre" caption="Cliente" visible={clientId == null} />
                {/* <Column dataField="typeId" width={150} caption="Tipo Documento" visible={clientId == null}>
                    <Lookup disabled={true} dataSource={createStoreLocal({name : 'billType'})} valueExpr="id" displayExpr="name" />
                </Column>                  */}
                <Column dataField="paymentTypeId" width={130} caption="Tipo pago">
                    <Lookup disabled={true} dataSource={createStoreLocal({ name: 'billPaymentType' })} valueExpr="id" displayExpr="name" />
                </Column>
                <Column dataField="total" width={100} cellRender={cellRender()} />
                <Column dataField="balance" width={100} caption="Deuda" cellRender={cellRender()} />
                <Column dataField="active" width={100} caption="Activa" />
                <Column dataField="payoff" width={100} caption='Pagada' dataType="boolean" visible={typeId == typesBill.factura} cellRender={cellAsPayoff} />
                <Column dataField="inverseParentId" width={100} caption='Factura' visible={typeId == typesBill.cotizacion} cellRender={formatId} />
                <Column dataField="createBy" caption='Creado por' width={100} visible={false} />
                <Column dataField="createAt" caption='Creado el' dataType='date' format={formatDateTime} width={180} visible={false} />
            </DataGrid>
        </div>
    );
}

export default List;
